<template>
  <li
    class="kd-thumbnail"
    :class="[ isActive ? 'kd-thumbnail--is-active' : '' ]"
    @click="ACTIVATE_SIDE_BY_ID(id);"
  >
    <div
      class="kd-thumbnail__image"
      :style="{ backgroundImage: thumbnailUrlCss }"
    ></div>
    <div class="kd-thumbnail__title">{{ name }}</div>
  </li>
</template>

<script>
import { mapActions } from 'vuex';
import {
  ACTIVATE_SIDE_BY_ID,
} from '@/store/action-types';

export default {
  props: {
    isActive: Boolean,
    id: String,
    name: String,
    thumbnailUrl: String,
  },
  computed: {
    thumbnailUrlCss() {
      return `url(${this.thumbnailUrl})`;
    },
  },
  methods: {
    ...mapActions([
      ACTIVATE_SIDE_BY_ID,
    ]),
  },
};
</script>

<style lang="scss">
  .kd-thumbnail__image {
    width: 80px;
    height: 80px;
    background-color: #EBEBEB;
    background-size: cover;
    margin-bottom: 10px;
    border: 2px solid transparent;

    @media all and (max-height: 680px) {
      width: 60px;
      height: 60px;
    }
  }

  .kd-thumbnail__title {
    text-align: center;
    font-weight: 600;
    font-size: 13px;
  }

  .kd-thumbnail {
    cursor: pointer;

    &:hover {
      opacity: 0.85;
    }

    & + & {
      margin-left: 20px;
    }

    &--is-active {
      .kd-thumbnail__image {
        border-color: #00A3E0; /* TODO: Create variables.scss */
      }

      .kd-thumbnail__title {
        color: #00A3E0;
      }
    }
  }
</style>
